import { httpRequest } from "@/utils/HttpRequest";
import { ISearchPage, IPage } from "@/types/ScmTypes";

export interface IBillMonitorDetail {
    id: string, // string
    beginNum?: string,   // 2
    bookOccupyNum?: string,   // null
    busSaleNum?: string,   // null
    busSreturnNum?: string,   // null
    compensateNum?: string,   // null
    currentNum?: string,   // 2
    differenceNum?: string,   // 0
    maintainNum?: string,   // null
    maintainOccupyNum?: string,   // null
    materialCode?: string,   // "612600060133"
    materialName?: string,   // "外置节温器"
    mreturnNum?: string,   // null
    occupyDifference?: string,   // 0
    occupyNum?: string,   // 0
    preturnNum?: string,   // 0
    preturnOccupyNum?: string,   // 0
    purchasePrice?: string,   // 85
    purchasePriceLatest?: string,   // 85
    purhcaseNum?: string,   // 2
    remainNum?: string,   // 2
    saleNum?: string,   // 0
    saleOccupyNum?: string,   // 0
    shopId?: string,   // "64eec0c1d6f37078b6b460e4cb0ac9d7"
    sreturnNum?: string,   // 0
    stockCost?: string,   // 170
    stockCostLatest?: string,   // 170
    unusualSreturnNum?: string,   // 0
    [key: string]: any
}

//搜索条件
export interface IBillMonitorSearchFields {
    [key: string]: any
}

export interface IBillMonitorSearch
    extends IBillMonitorSearchFields, ISearchPage {

}
export interface IStatistics {
    diffStatus: number;
    diffAmount: number;
    diffNum: number;
}




//进销存报表
class BillMonitorService {
    async page(searchVo: IBillMonitorSearch) {
        const apiUrl = "/zzw-vrm/bill/monitoring/page";
        return await httpRequest.post<IPage<IBillMonitorDetail>>(apiUrl, searchVo);
    }
    async export(searchVo: IBillMonitorSearch) {
        const apiUrl = "/zzw-vrm/bill/monitoring/export";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }
    // 头部统计
    async statistics(searchVo: IBillMonitorSearch) {
        const apiUrl = "/zzw-vrm/bill/monitoring/statistics";
        return await httpRequest.post<IStatistics>(apiUrl, searchVo);
    }

}

export const billMonitorService = new BillMonitorService();